import { Button, cn } from '@sib/ui';
import { ArrowRight } from '@sib/ui/icons';
import { useUIContext } from '../../UIContext';
import { SidebarItem } from './SidebarItem';
import { useSidebarItems } from './Sidebar.utils';

interface SidebarProps {
  onChange: (state: boolean) => void;
  open: boolean;
  hidden: boolean;
}

export const Sidebar = ({ onChange, open, hidden }: SidebarProps) => {
  const sidebarItems = useSidebarItems();
  const { submenuOpen, setSubmenuOpen } = useUIContext();

  return (
    <aside
      className={cn(
        'transition-width z-20 flex h-full flex-col overflow-x-hidden overflow-y-auto border-r bg-white duration-400',
        hidden ? 'w-0 overflow-x-visible' : open ? 'w-64' : 'w-13'
      )}
    >
      <nav className="w-64 flex-[1_1] flex-col border-r">
        {sidebarItems.map(item => (
          <SidebarItem
            key={`sidebar-item-${item.title}`}
            {...item}
            open={open}
            isExpandedSubmenu={item.hasExpandSubmenuArrow && submenuOpen}
            onExpandSubmenuClick={() => setSubmenuOpen(!submenuOpen)}
          />
        ))}
      </nav>
      <div className="flex w-full flex-col items-center gap-1 pb-2">
        <Button
          className={cn('flex w-full items-center justify-end')}
          variant="ghost"
          onClick={() => onChange(!open)}
        >
          <ArrowRight
            className={cn(
              'min-size-4.5 transition-transform duration-300',
              open && 'rotate-y-180'
            )}
          />
        </Button>
        <p className="text-muted-foreground flex flex-nowrap items-center justify-center gap-0.5 text-[10px]">
          <span
            className={cn(
              'overflow-hidden whitespace-nowrap transition-all duration-300',
              open ? 'max-w-30' : 'max-w-0'
            )}
          >
            {__APP_DISPLAY_NAME__}
          </span>
          <span>{__APP_VERSION__}</span>
        </p>
      </div>
    </aside>
  );
};
